<template>
	<div class="form">
		<h4 class="step-title my-1">
			How long have you been insured with
			{{ lead.autoInsurance.currentInsurer }}?
		</h4>
		<div
			class="step-content d-flex flex-column align-items-center step-button-list wider"
		>
			<button-list
				v-bind:items="insuranceLengths"
				v-bind:onclick="complete"
				v-bind:value="lead.autoInsurance.currentInsurerLengthInMonths"
			/>
		</div>
	</div>
</template>

<script>
import ButtonList from "../shared/ButtonList.vue";

export default {
	name: "CurrentAutoInsurerLength",
	components: {
		ButtonList,
	},
	data: function () {
		return {
			insuranceLengths: [
				{ text: "5+ years", value: 60 },
				{ text: "3-5 years", value: 48 },
				{ text: "2-3 years", value: 30 },
				{ text: "1-2 years", value: 18 },
				{ text: "Less than 1 year", value: 6 },
			],
		};
	},
	props: {
		lead: Object,
	},
	methods: {
		complete: function (value) {
			this.lead.autoInsurance.currentInsurerLengthInMonths = value;
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
